<template>
    <div class="viewbooking">
        <Viewbooking></Viewbooking>
    </div>
</template>

<script>
    import Viewbooking from '@/components/viewbooking_component.vue';

    export default {
        name: 'view_Booking',
        data() {
            return {
            }
        },
        components: {
            Viewbooking
        }
    }
</script>